import moment from 'moment-jalaali';
import { RegularExpressions } from '../../constants/regular-expressions';

export {};

//#region text size
String.prototype.getSizeOfKB = function (this: string): number {
  return new TextEncoder().encode(this).length / 100000;
};
String.prototype.getSizeOfMB = function (this: string): number {
  return new TextEncoder().encode(this).length / 1000000;
};
String.prototype.getSizeOfGB = function (this: string): number {
  return new TextEncoder().encode(this).length / 10000000;
};
//#endregion

//#region string regex
String.prototype.getJustNumber = function (this: string): any {
  return this.replace(RegularExpressions.onlyNumbers, '').replace(
    /^\s*\n/gm,
    '',
  );
};
String.prototype.splitByNewLine = function (this: string): any {
  return this.split(RegularExpressions.newLine);
};
String.prototype.splitBySemicolon = function (this: string): any {
  return this.split(';');
};
String.prototype.splitByComma = function (this: string): any {
  return this.split(',');
};
String.prototype.removeEmptyLine = function (this: string): string {
  return this.replace(RegularExpressions.emptyLine, '');
};
String.prototype.appendNewLine = function (this: string): string {
  return this + '\n';
};
String.prototype.getJustNumbers = function (this: string): string {
  return this.replace(RegularExpressions.onlyNumbers, '').replace(
    /^\s*\n/gm,
    '',
  );
};
String.prototype.getJustNumbersAndComma = function (this: string): string {
  return this.replace(RegularExpressions.onlyNumbersAndComma, '').replace(
    /^\s*\n/gm,
    '',
  );
};
//#endregion

//#region mobileNumber

String.prototype.convertMobileNumberPrefixTo98 = function (
  this: string,
): string {
  return this.replace(
    RegularExpressions.mobileNumberPrefixTo98Global,
    '989$<num>',
  );
};
String.prototype.convertToMobileNumberArray = function (
  this: string,
): string[] {
  return this.match(RegularExpressions.mobileNumberPrefixTo98Global) ?? [];
};
String.prototype.getWrongMobileNumber = function (this: string): string {
  return this.replace(RegularExpressions.mobileNumberPrefixTo98Global, '');
};

String.prototype.convertToGlobalMobileNumberArray = function (
  this: string,
): string[] {
  return this.match(RegularExpressions.globalAndInternalMobileNumbers) ?? [];
};
String.prototype.getWrongGlobalMobileNumber = function (this: string): string {
  return this.replace(RegularExpressions.globalAndInternalMobileNumbers, '');
};
//#endregion

//#region date time
String.prototype.toUTC = function (this: string): string {
  return moment(this).format('YYYY-MM-DDTHH:mm:ss.sssZ');
};
String.prototype.toShamsi = function (this: string): string {
  // return date.toLocaleDateString('fa-IR', { year: 'numeric', month: '2-digit', day: '2-digit' });
  return moment(this).format('jYYYY/jM/jD');
};
String.prototype.shamsiToUTC = function (this: string): string {
  return moment(this, 'jYYYY/jM/jD HH:mm:ss').format(
    'YYYY-MM-DDTHH:mm:ss.sssZ',
  );
};
String.prototype.UTCToShamsi = function (this: string): string {
  return moment(this, 'YYYY-MM-DDTHH:mm:ss.sssZ').format(
    'jYYYY/jM/jD HH:mm:ss',
  );
};
String.prototype.removeTimeSeconds = function (this: string): string {
  return this.substring(0, 5);
};
//#endregion
